import React, { useState } from 'react';
import styled from 'styled-components';
import { FaHeart } from "react-icons/fa";
import Button from "../parts/Button";
import { GetUserSession200Response } from "../../../api/v1";
import { api } from '../../../api';

type FavoriteShopComponentProp = {
  shopId: number
  favoriteFlag: boolean
  session: GetUserSession200Response
}

const FavoriteButtonStyle = styled(Button)<{liked: boolean}>`
  display: flex;
  align-items: center;
  background: ${props => props.liked ? 'hotpink' : '#393432'};
  justify-content: center;
  margin-bottom: 15px;

  svg {
    font-size: 20px;
  }

  &:hover {
    background: ${props => props.liked ? '#ff88c3' : '#696767'};;
  }
`;
const FavoriteShopButton: React.FC<FavoriteShopComponentProp> = ({ shopId , favoriteFlag, session }) => {
  const [favoriteShopFlag, setFavoriteShopFlag] = useState<boolean>(favoriteFlag);
  const onFavoriteButton = ((event, shopId: number) => {
    event.preventDefault();
    const params = {
      favoriteShop: {
        shopId,
        userId: session?.userId
      }
    };
    api.postFavoriteShop(params).then(() => setFavoriteShopFlag(!favoriteShopFlag)).catch(() => window.alert('ログインをすると、お気に入りすることができます。'));
  });

  return (
    <FavoriteButtonStyle liked={favoriteShopFlag} onClick={event => onFavoriteButton(event, shopId)} ariaLabel='お気に入りボタン'>
      <FaHeart />
    </FavoriteButtonStyle>
  );
};

export default FavoriteShopButton;
